import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="bg-pearl py-12 lg:py-16 overflow-hidden relative" data-id="element-103">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-104">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center" data-id="element-105">
          {/* Left Column - Text (60%) */}
          <motion.div className="lg:col-span-7 flex flex-col items-center text-center" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-106">
            {/* Badge - always visible */}
            <span className="inline-block font-inter font-semibold text-gold tracking-[0.2em] text-[13px] uppercase mb-6 border border-gold/40 rounded-md px-4 py-2" data-id="element-107">
              NUTRIȚIE ȘTIINȚIFICĂ ȘI OPTIMIZARE METABOLICĂ
            </span>

            {/* H1 - always visible */}
            <h1 className="text-center lg:text-left text-4xl md:text-5xl lg:text-6xl font-montserrat font-bold text-navy leading-tight mb-6 tracking-tight" data-id="element-108">
              De la oboseală și ceață mentală, la energie stabilă și claritate
            </h1>

            {/* Mobile-only image: shows between title and subtitle */}
            <div className="block lg:hidden w-full mb-8 relative" data-id="element-109">
              <div className="absolute -bottom-4 -right-4 w-full h-full bg-gold rounded-xl" data-id="element-110"></div>
              <div className="absolute -top-4 -right-4 bg-navy text-pearl px-4 py-3 rounded-xl shadow-xl z-20 border border-gold/20" data-id="element-111">
                <p className="font-montserrat font-bold text-[14px] text-white leading-tight" data-id="element-112">
                  dr.ing. Radu Pascu
                </p>
                <div className="flex items-center gap-2 mt-1" data-id="element-113">
                  <div className="w-6 h-[2px] bg-gold rounded-full" data-id="element-114"></div>
                  <span className="font-inter text-gold text-[11px] font-semibold tracking-wide uppercase" data-id="element-115">
                    8+ ani experiență
                  </span>
                </div>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/jWbo5TMFxCjwve3KjybZLZ/546630565_24424827897197605_3456442442638922989_n.jpg" alt="dr.ing. Radu Pascu — Specialist în Nutriție Științifică" className="relative aspect-[4/5] rounded-xl shadow-2xl z-10 object-cover object-top w-full ring-1 ring-white/20" data-id="element-116" />
            </div>

            {/* Subtitle */}
            <p className="text-center font-lora text-[19px] md:text-xl text-text-medium mb-10 max-w-[640px] leading-relaxed" data-id="element-117">
              Un sistem de 6 luni pentru profesioniști care vor să slăbească
              sustenabil, să-și recapete energia și să devină stăpâni pe propria
              biologie. Fără diete generice. Cu date reale despre corpul tău.
            </p>

            {/* CTA */}
            <div className="flex flex-col items-center lg:items-start gap-4 w-full max-w-md" data-id="element-118">
              <a href="https://nutrisib.club/formular" className="bg-gold text-navy font-inter font-bold uppercase tracking-wide px-8 py-4 rounded-md w-full md:w-auto hover:-translate-y-0.5 hover:shadow-lg transition-all duration-200 text-center no-underline inline-block" data-id="element-119">
                Programează Evaluarea Gratuită C.E.L.O.S.
              </a>
              <p className="font-inter text-sm text-text-light leading-relaxed text-center lg:text-left" data-id="element-120">
                Dacă ai încercat diete, aplicații și suplimente de pe internet
                și tot ești în același loc, problema nu ești tu. E lipsa unui
                sistem care să țină cont de corpul tău real.
              </p>
            </div>
          </motion.div>

          {/* Right Column - Image (desktop only) */}
          <motion.div className="hidden lg:block lg:col-span-5 relative" initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-121">
            {/* Large gold square behind */}
            <div className="absolute -bottom-5 -right-5 w-full h-full bg-gold rounded-xl" data-id="element-122"></div>

            {/* Navy corner accent top-left */}
            <div className="absolute -top-3 -left-3 w-20 h-20 border-t-[3px] border-l-[3px] border-navy rounded-tl-xl z-20" data-id="element-123"></div>

            {/* Gold corner accent bottom-right */}
            <div className="absolute -bottom-8 -right-8 w-20 h-20 border-b-[3px] border-r-[3px] border-gold/60 rounded-br-xl z-20" data-id="element-124"></div>

            {/* Dot pattern accent */}
            <div className="absolute -top-8 -right-4 w-24 h-24 z-0 opacity-30" style={{
            backgroundImage: 'radial-gradient(#C5A021 2px, transparent 2px)',
            backgroundSize: '10px 10px'
          }} data-id="element-125"></div>

            {/* Credential badge top-right */}
            <div className="absolute -top-4 -right-4 bg-navy text-pearl px-5 py-4 rounded-xl shadow-xl z-20 border border-gold/20" data-id="element-126">
              <p className="font-montserrat font-bold text-[17px] text-white leading-tight" data-id="element-127">
                dr.ing. Radu Pascu
              </p>
              <div className="flex items-center gap-2 mt-1.5" data-id="element-128">
                <div className="w-8 h-[2px] bg-gold rounded-full" data-id="element-129"></div>
                <span className="font-inter text-gold text-[13px] font-semibold tracking-wide uppercase" data-id="element-130">
                  8+ ani experiență
                </span>
              </div>
            </div>

            {/* Small gold bar accent */}
            <div className="absolute top-1/2 -left-6 w-3 h-16 bg-gold rounded-full z-20" data-id="element-131"></div>

            <img src="https://cdn.magicpatterns.com/uploads/jWbo5TMFxCjwve3KjybZLZ/546630565_24424827897197605_3456442442638922989_n.jpg" alt="dr.ing. Radu Pascu — Specialist în Nutriție Științifică" className="relative aspect-[4/5] rounded-xl shadow-2xl z-10 object-cover object-top w-full ring-1 ring-white/20" data-id="element-132" />
          </motion.div>
        </div>
      </div>
    </section>;
}